import { createContext, useContext } from 'react';
import { createContextualCan } from '@casl/react';
import { createMongoAbility } from '@casl/ability';

const ability = createMongoAbility();
export const AbilityContext = createContext<typeof ability>(undefined);
export const Can = createContextualCan(AbilityContext.Consumer);
